﻿import $ from "jquery";
import { GuiDetailGeneric } from "../../GuiDetailGeneric";

declare class Quill {
	constructor(container: string | Element, options?: object);
	getContents(): unknown;
	root: HTMLElement;
}

export class GuiDetailNachricht extends GuiDetailGeneric {

    quill?: Quill;
    constructor() {
        super("Nachricht");

        this.setupHtmlEditor();
    }


    setupHtmlEditor() {
        const toolbarconfig = [
            ["bold", "italic", "underline", "strike"],        // toggled buttons
            ["link", "image"],

            //[{ 'header': 1 }, { 'header': 2 }],               // custom button values
            [{ 'list': "ordered" }, { 'list': "bullet" }],
            [{ 'script': "sub" }, { 'script': "super" }],      // superscript/subscript
            [{ 'indent': "-1" }, { 'indent': "+1" }],          // outdent/indent
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

            [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
            //            [{ 'font': [] }],
            [{ 'align': [] }],

            ["clean"]                                         // remove formatting button
        ];


        const options = {
            theme: "snow",
            placeholder: "Compose an epic...",
            modules: { toolbar: toolbarconfig }
        };

        this.quill = new Quill("#editor", options);
    }

    protected override beforeSave() {

        if (this.quill == undefined) return;

        this.quill.getContents();
        const content = this.quill.root.innerHTML; // or quill.getContents() for Delta
        $("#VmDetail_NachrichtText").val(content);
    }
}
